import { createAsyncThunk } from "@reduxjs/toolkit";
import { digitalData } from "../../Types/Types";
import axios from "axios";

export const getDigital = createAsyncThunk(
  "digital/getDigital",
  async (data, thunkApi) => {
    try {
      const response = await axios.get<digitalData[]>(
        "https://api.npoint.io/e5077724ce6efbbe3574"
      );

      return response.data;
    } catch (error: any) {
      const message = error.message;
      return thunkApi.rejectWithValue(message);
    }
  }
);
